import { ActionTypes } from '../constants/index';


export function updateApp(): Object {
  return {
    type: ActionTypes.CLIENT_APP_UPDATE_REQUEST,
    payload: {},
  };
}



// WEBPACK FOOTER //
// ./scripts/actions/client.js